export const DOMAIN = 'https://wohnungsraeumungwien.at';
export const PHONE = '+43 699 17170002';
export const PHONE_LINK = 'tel:+4369917170002';
export const WHATSAPP = 'https://wa.me/4369917170002';
export const WEB3FORMS_KEY = '53fc7e03-7cc4-47f5-a5b3-57f8e3b0d6e2';
export const ADDRESS = 'Märzstraße 71/1-7, 1150 Wien';
export const COMPANY = 'Wohnungsräumung Wien';

export const AREAS_UMGEBUNG = [
  'Klosterneuburg', 'Mödling', 'Schwechat', 'Wiener Neustadt', 'Baden bei Wien'
];

export const WIEN_BEZIRKE = [
  { code: '1010', name: 'Innere Stadt' },
  { code: '1020', name: 'Leopoldstadt' },
  { code: '1030', name: 'Landstraße' },
  { code: '1040', name: 'Wieden' },
  { code: '1050', name: 'Margareten' },
  { code: '1060', name: 'Mariahilf' },
  { code: '1070', name: 'Neubau' },
  { code: '1080', name: 'Josefstadt' },
  { code: '1090', name: 'Alsergrund' },
  { code: '1100', name: 'Favoriten' },
  { code: '1110', name: 'Simmering' },
  { code: '1120', name: 'Meidling' },
  { code: '1130', name: 'Hietzing' },
  { code: '1140', name: 'Penzing' },
  { code: '1150', name: 'Rudolfsheim-Fünfhaus' },
  { code: '1160', name: 'Ottakring' },
  { code: '1170', name: 'Hernals' },
  { code: '1180', name: 'Währing' },
  { code: '1190', name: 'Döbling' },
  { code: '1200', name: 'Brigittenau' },
  { code: '1210', name: 'Floridsdorf' },
  { code: '1220', name: 'Donaustadt' },
  { code: '1230', name: 'Liesing' },
];

export const SERVICE_PAGES = [
  { title: 'Wohnungsräumung', fullTitle: 'Wohnungsräumung Wien', slug: '/wohnungsraeumung-wien' },
  { title: 'Haushaltsauflösung', fullTitle: 'Haushaltsauflösung Wien', slug: '/haushaltsaufloesung-wien' },
  { title: 'Nachlassräumung', fullTitle: 'Nachlassräumung Wien', slug: '/nachlassraeumung-wien' },
  { title: 'Messie-Wohnung', fullTitle: 'Messie-Wohnung Wien', slug: '/messie-wohnung-wien' },
  { title: 'Kellerräumung', fullTitle: 'Kellerräumung Wien', slug: '/kellerraeumung-wien' },
  { title: 'Büroräumung', fullTitle: 'Büroräumung Wien', slug: '/bueroraeumung-wien' },
  { title: 'Dachbodenräumung', fullTitle: 'Dachbodenräumung Wien', slug: '/dachbodenraeumung-wien' },
];

export const P = {
  hero: 'https://images.unsplash.com/photo-1680918029754-3d6765210647?w=1920&q=80',
  heroBefore: 'https://images.unsplash.com/photo-1591528287446-43c9c0e1075e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400',
  heroAfter: 'https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=1400&q=80',
  pricingBoxes: 'https://images.unsplash.com/photo-1719600804011-3bff3909b183?w=700&q=60',
  clutteredRoom: 'https://images.unsplash.com/photo-1692890658961-06971bb40cfa?w=900&q=80',
  movingBoxes: 'https://images.unsplash.com/photo-1714647211923-a3881cd1300f?w=900&q=80',
  furniturePile: 'https://images.unsplash.com/photo-1653286859854-8fad9de85459?w=900&q=80',
  workersUnloading: 'https://images.unsplash.com/photo-1526384133018-201452728d6c?w=700&q=80',
  worker1: 'https://images.unsplash.com/photo-1590493574015-600d56de7772?w=700&q=80',
  truck: 'https://images.unsplash.com/photo-1698917414969-feade59e3343?w=700&q=80',
  loadingVan: 'https://images.unsplash.com/photo-1680918029754-3d6765210647?w=700&q=80',
  clutteredBoxes: 'https://images.unsplash.com/photo-1725278484721-b20373781f43?w=900&q=80',
  emptyRoom: 'https://images.unsplash.com/photo-1757742690834-aa581b9f53b2?w=900&q=80',
  processBoxes: 'https://images.unsplash.com/photo-1589803010842-41cdf85bf0f9?w=900&q=80',
  garbageTruck: 'https://images.unsplash.com/photo-1672839792786-88b2dddd57d9?w=700&q=80',
  boxesRack: 'https://images.unsplash.com/photo-1591528287637-f3d5eaa83a3c?w=700&q=80',
  atticBefore: 'https://images.unsplash.com/photo-1768050197707-5576b319e2d3?crop=entropy&cs=srgb&fm=jpg&q=85&w=900',
};
